export default __webpack_public_path__ + "static/media/NCIsrael.055285c5.png";